var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',{attrs:{"title":"围手术期管理系统","logo":_vm.logo}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }